import { ColumnType } from "antd/lib/table";
import { compact } from "lodash";
import { EMPTY } from "constants/common";
import { AiccDefaultScenario, AiccVoiceGender } from "types/model/aiccLearningAssets";
import getActionColumn, { AssetColumnHandlers } from "../getActionColumn";
import { AICC_VOICE_GENDER_LABEL } from "./configs";

const getColumns = ({ isEditable, canDelete, onEdit, onDelete }: AssetColumnHandlers<AiccDefaultScenario>) =>
  compact<ColumnType<AiccDefaultScenario>>([
    {
      title: "Scenario Title",
      dataIndex: "title",
      key: "title",
      width: 200,
      render: (title) => title || EMPTY,
    },
    {
      title: "Learner Context Description",
      dataIndex: "learnerContextDescription",
      key: "learnerContextDescription",
      width: 320,
      render: (learnerContextDescription) => learnerContextDescription || EMPTY,
    },
    {
      title: "AI Context Description",
      dataIndex: "aiContextDescription",
      key: "aiContextDescription",
      width: 320,
      render: (aiContextDescription) => aiContextDescription || EMPTY,
    },
    {
      title: "Voice Gender",
      dataIndex: "voiceGender",
      key: "voiceGender",
      width: 140,
      render: (voiceGender) => AICC_VOICE_GENDER_LABEL[voiceGender as AiccVoiceGender] || EMPTY,
    },
    isEditable && getActionColumn<AiccDefaultScenario>({ canDelete, onEdit, onDelete }),
  ]);

export default getColumns;
